export const COOKIE_ID = "saved_offers";
